export default __webpack_public_path__ + "static/media/wallart4.32c4d9ef.jpg";